<span class="title-inner">
  <span class="title-text">
    <ng-content></ng-content>
    <ng-content select="[title-content]"></ng-content>
    <ng-content select="cs-tooltip"></ng-content>
  </span>
  <ng-content select="[title-action]"></ng-content>
  <ng-content select="cs-button"></ng-content>
</span>
<ng-content select="cs-note"></ng-content>